<template>
  <div>
    <div id="dContent">
      <div id="cNav" sty>
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Wenchuang'}">精品文创</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{ title }}
      </div>
      <div id="wcOne">
        <div id="wcOne_left">
          <div class="slider">
            <div v-for="(item, index) in data" :key="index">
              <input type="radio" name="slide_switch" :id="'id'+index" checked="checked" />
              <label :for="'id'+index">
                <img :src="item" width="100" style="object-fit: cover;"/>
              </label>
              <img :src="item" />
            </div>
          </div>
        </div>
        <div id="wcOne_right">
          <div id="wcdetial" style="text-align: left;position: relative;">
            <div id="wctitles" style="font-size: 1.3em;line-height: 50px;">{{tableData.title}}</div>
            <div id="wccontents" style="font-size: 1em;text-align: left;line-height: 30px;" v-html="tableData.contents"></div>
            <div style="clear: both;"></div>
            <div id="price" style="font-size: 1em;line-height: 40px;"><span>￥</span>：<span style="color: #FF2222;">{{tableData.price}}</span></div>
            <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
              <div style="float: left;font-size: 1.2em;margin-right: 70px;">分享到：<div style="float: right;">
                  <share :config="config"></share>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div id="mdContent">
      <div id="mcNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Wenchuang'}">精品文创</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{ title }}
      </div>
      <div id="mwcOne">
        <div id="mwcOne_left">
          <div id="slider">
            <div v-for="(item, index) in mdata" :key="index">
              <input type="radio" name="slide_switch" :id="'id'+index" checked="checked" />
              <label :for="'id'+index">
                <img :src="item" style="width: 50px;height: 40px;object-fit: cover;" />
              </label>
              <img :src="item" />
            </div>
          </div>
        </div>
        <div id="mwcOne_right">
          <div id="mwcdetial" style="text-align: left;position: relative;">
            <div id="mwctitles" style="font-size: 1.1em;line-height: 30px;color: #m956f17;">{{mtableData.title}}</div>
            <div id="mwccontents" style="font-size: 1em;text-align: left;line-height: 30px;" v-html="mtableData.contents"></div>
          </div>
        </div>
        <div id="mprice" style="font-size: 1em;line-height: 30px;text-align: left;"><span>￥</span>：<span style="color: #mFF2222;">{{mtableData.price}}</span></div>
        <div style="margin-top: 20px;"></div>
      </div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;margin-right: 70px;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        tableData: [],
        imgData: [],
        data: [],
        mtableData: [],
        mimgData: [],
        mdata: [],
        title: '',
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1
        }
      }
    },
    mounted() {
      $("body,html").animate({
        scrollTop: 0
      }, 1);
      if (this.isMobile()) {
        document.getElementById("dContent").style.display = "none";
        this.mhandleSearch();
      } else {
        document.getElementById("mdContent").style.display = "none";
        document.getElementById("dContent").style.display = "block";
        let eWidth = document.body.clientWidth;
        document.getElementById("dContent").style.width = eWidth + "px";
        document.getElementById("wcOne").style.width = eWidth * 0.9 + "px";
        document.getElementById("wcOne").style.marginLeft = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("wcOne").style.marginRight = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("cNav").style.marginLeft = (eWidth - eWidth * 0.9) / 2 + "px";
        this.handleSearch();
      };
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        this.search();
      },
      JupUrlVR: function() {
        window.open("http://mp.weixin.qq.com")
      },
      // 查询列表
      search: function() {
        let that = this;
        this.id = this.$route.query.id;
        this.loading = true;
        let url = this.HOST + '/api/v1/literary/getOne/' + this.$route.query.id + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if (cData && cData.data) {
            that.tableData = cData.data;
            let urlimg = that.HOST + '/api/v1/literary/literaryIdAll/' + that.$route.query.id + '';
            that.$axios.get(urlimg).then(function(result) {
              let cData = result.data;
              if (cData && cData.data) {
                that.imgData = cData.data;
                for (let i = 0; i < that.imgData.length; i++) {
                  that.data.push(that.imgData[i].images)
                }
              }
            }).catch(function(error) {
              console.log(err);
            })
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
      mhandleSearch() {
        this.msearch();

      },
      // 查询列表
      msearch: function() {
        let that = this;
        this.id = this.$route.query.id;
        this.loading = true;
        let url = this.HOST + '/api/v1/literary/getOne/' + this.$route.query.id + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if (cData && cData.data) {
            that.mtableData = cData.data;
            let urlimg = that.HOST + '/api/v1/literary/literaryIdAll/' + that.$route.query.id + '';
            that.$axios.get(urlimg).then(function(result) {
              let cData = result.data;
              if (cData && cData.data) {
                that.mimgData = cData.data;
                for (let i = 0; i < that.mimgData.length; i++) {
                  that.mdata.push(that.mimgData[i].images)
                }
              }
            }).catch(function(error) {
              console.log(err);
            })
          }
        }).catch(function(error) {
          console.log(err);
        })
      },
    }
  }
</script>

<style scoped>
  #dContent {
    display: none;
  }

  #dContent>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #dContent>#cNav>span:nth-child(1),
  #dContent>#cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #dContent>#cNav>span:nth-child(1):hover,
  #dContent>#cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #dContent>div:nth-child(2) {
    height: 500px;
  }

  #dContent>div:nth-child(3) {
    height: 150px;
  }

  .swiper-container {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .gallery-top {
    height: 80%;
    width: 100%;
  }

  .gallery-thumbs {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  p {
    margin: 0;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }

  #introduce {
    text-align: left;
    line-height: 30px;
    text-indent: 25px;
    margin-bottom: 50px;
  }

  #wcOne_left {
    width: 50%;
    height: 500px;
    float: left;
    overflow: hidden;
  }

  #wcOne_right {
    width: 50%;
    height: 500px;
    float: left;
  }

  #wcdetial {
    width: 95%;
    /*height: 450px;*/
    margin-left: 5%;

  }

  .slider {
    position: relative;
    padding-top: 380px;
    width: 100%;
    margin: 0 auto 100px auto;

    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.75);
  }

  .slider>div>img {
     position: absolute;
    left: 50%;  /* 第一步：将图片左边缘移到容器水平中点 */
    top: 0;
    transition: all .5s;
    width: auto;  /* 关键：取消宽度强制100%，使用图片实际宽度 */
    height: 100%; /* 保持高度占满容器 */
    transform: translateX(-50%) !important; /* 第二步：向左偏移自身宽度的50%，实现水平居中 */
    max-width: 100%;
  }

  .slider div input[name='slide_switch'] {
    display: none;
  }

  .slider div label {
    margin: 18px 0 0 8px;
    border: 3px solid #999;
    float: left;
    height: 70px;
    width: 100px;
    cursor: pointer;
    transition: all 0.5s;
    opacity: 0.6;
  }

  .slider div label img {
    display: block;
    height: 100%;
    width: 100%;
  }

  .slider div input[name='slide_switch']:checked+label {
    border-color: #666;
    opacity: 1;
  }

  .slider div input[name='slide_switch']~img {
    opacity: 0;
    transform: scale(1.1);
  }

  .slider div input[name='slide_switch']:checked+label+img {
    opacity: 1;
    transform: scale(1);
  }

  /*mobile*/
  #mdContent {
    margin: auto 20px;
  }

  #mdContent>#mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mdContent>#mcNav>span:nth-child(1),
  #mdContent>#mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mdContent>#mcNav>span:nth-child(1):hover,
  #mdContent>#mcNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #mdContent>div:nth-child(2) {
    /*height: 450px;*/
  }

  #mdContent>div:nth-child(3) {
    /*height: 150px;*/
  }

  .swiper-container {
    width: 100%;
    /*height: 300px;*/
    margin-left: auto;
    margin-right: auto;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .gallery-top {
    height: 80%;
    width: 100%;
  }

  .gallery-thumbs {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  p {
    margin: 0;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }

  #mintroduce {
    text-align: left;
    line-height: 30px;
    text-indent: 25px;
    margin-bottom: 50px;
  }

  #mwcOne_left {
    width: 100%;
    /*height: 450px;*/
    margin-top: 30px;
    overflow: hidden;
  }

  #mwcOne_right {
    width: 100%;
    margin-top: 30px;
    /*height: 450px;*/
  }

  #mwcdetial {
    width: 100%;
  }

  #slider {
    position: relative;
    padding-top: 320px;
    width: 100%;
    margin: 0 auto 50px auto;

    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.75);
  }

  #slider>div>img {
    position: absolute;
    left: 0;
    top: 0;
    transition: all 0.5s;
    width: 100%;
    height: 100%;
  }

  #slider div input[name='slide_switch'] {
    display: none;
  }

  #slider div label {
    margin: 18px 0 0 8px;
    border: 3px solid #999;
    float: left;
    cursor: pointer;
    transition: all 0.5s;
    opacity: 0.6;
  }

  #slider div label img {
    display: block;
  }

  #slider div input[name='slide_switch']:checked+label {
    border-color: #666;
    opacity: 1;
  }

  #slider div input[name='slide_switch']~img {
    opacity: 0;
    transform: scale(1.1);
  }

  #slider div input[name='slide_switch']:checked+label+img {
    opacity: 1;
    transform: scale(1);
  }
</style>



// WEBPACK FOOTER //
// src/pages/wenchuangDetials.vue